import { Platform } from 'react-native';
import { CaretLeft, ArrowLeft } from '../Icons';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '../../navigationApp/types';
import { ThemedTouchableOpacity } from '../../theme/Components';
import {useDarkMode} from '@app/utils';
import { useAppSelector } from '@app/store/hooks';
import ROUTE from '@app/navigationApp/routes';
import { useIsEnhanceLimit } from '@app/hooks/useIsEnhanceLimit';
import { CreditApplicationSubType, CreditApplicationType } from '@app/configs/constants';
import { useTheme } from '@shopify/restyle';
import { Theme } from '@app/theme';
import { updateLMSUserDashboard } from '@app/store/slices/commonSlice';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';


type BackButtonProps = NativeStackNavigationProp<PrivateStackParamList , keyof PrivateStackParamList>

export const HIDE_BACK_BUTTON_PAGES = [
  "MF_FETCH_PORTFOLIO",
  "UNLOCK_LIMIT_LANDING",
  "MF_PLEDGE_PORTFOLIO",
  "KYC_STEPPER",
]

const BackButton = ({ navigation , pageName, manualHandle, customGoBackAction  } : {navigation : BackButtonProps , pageName? :keyof PrivateStackParamList, manualHandle?: Function, customGoBackAction?: Function }) => {
  const dispatch = useDispatch()
  const {showHome, isPLJ} = useAppSelector(state => state.platformParams)
  const isLMSUser = useAppSelector((state) => state.commonReducer.isLMSUser);
  const {userDetails} = useAppSelector(state => state.auth)
  const {isFromEnhanceLimit} = useIsEnhanceLimit();
  const [showBackButton, setShowBackButton] = useState(true);
  const { colors } = useTheme<Theme>()

  useEffect(() => {
    if (
      showHome === false &&
      pageName &&
      HIDE_BACK_BUTTON_PAGES.includes(pageName)
    ) {
      isFromEnhanceLimit === false
        ? setShowBackButton(false)
        : setShowBackButton(true)
    }
  }, [
    isFromEnhanceLimit,
    pageName,
    showHome
  ])

  const handleGoBack = () => {
    if(isLMSUser){
      dispatch(updateLMSUserDashboard({isLMSUserDashboard:true}))
    }
    if(
      (
        pageName === ROUTE.DIGIO_MANDATE_SIGN ||
        pageName === ROUTE.BANK_ACCOUNT_VERIFICATION
      ) &&
      userDetails?.linkedApplications?.[0]?.applicationType === CreditApplicationType.CREDIT_LOAN_SERVICING_APPLICATION_AGAINST_SECURITIES &&
      userDetails?.linkedApplications?.[0]?.creditApplicationSubType === CreditApplicationSubType.MANDATE_UPDATE
    ) {
      navigation.reset({
        index: 0,
        routes: [{ name: ROUTE.HOME }, {name: ROUTE.USER_PROFILE}, {name: ROUTE.ACCOUNT_DETAILS}]
      })
      return;
    }
    if(Platform.OS !== 'web') {
      if (navigation.canGoBack()) {
        navigation.goBack();
        return;
      }
    }
    if(customGoBackAction){
      customGoBackAction()
      return;
    }
    if((pageName === ROUTE.MANAGE_LIMIT_LANDING) && isFromEnhanceLimit) {
      navigation.navigate(ROUTE.HOME)
      return;
    }
    if((pageName === "MF_PLEDGE_PORTFOLIO" || pageName === "UNLOCK_LIMIT_LANDING") && showHome) {
      navigation.reset({
        index: 0,
        routes: [{ name: 'HOME' }]
      })
      return;
    } else if(pageName === ROUTE.ASSET_PLEDGE) {
      navigation.navigate(ROUTE.KYC_STEPPER)
      return;
    } else if(pageName === ROUTE.MF_FETCH_PORTFOLIO && isFromEnhanceLimit) {
      navigation.navigate(ROUTE.MANAGE_LIMIT_LANDING)
      return;
    }
    if(pageName === ROUTE.PORTFOLIO) {
      navigation.navigate(ROUTE.SET_CREDIT_LIMIT, {fromEditSelection: true});
      return;
    }
    if((pageName === "MFC_FETCH_ANCHOR" || pageName === "MF_FETCH_PORTFOLIO" || pageName === "KYC_PAN_VERIFICATION") && showHome) {
      navigation.reset({
        index: 0,
        routes: [{ name: 'HOME' }]
      })
    }  else if (pageName === "KYC_DOCUMENTS" || pageName === "KYC_PHOTO_VERIFICATION" || pageName === "KYC_ADDITIONAL_DETAILS" || pageName === "KYC_SUMMARY" || pageName === "BANK_ACCOUNT_VERIFICATION" || pageName === "DIGIO_MANDATE_SIGN" || pageName === "SIGN_DESK_ESIGN" || pageName === "DSP_KFS") {
      navigation.reset({
        index: 0,
        routes: [{ name: 'KYC_STEPPER' }]
      })
    } else if(pageName === "KYC_STEPPER" && showHome) {
      if(isFromEnhanceLimit) {
        navigation.navigate(ROUTE.MANAGE_LIMIT_LANDING)
        return;
      } else {
        navigation.reset({
          index: 0,
          routes: [{ name: 'HOME' }]
        })
      }
    } else if (navigation.canGoBack() && showHome  || (pageName === "PLEDGE_CONFIRMATION" || pageName === "SET_CREDIT_LIMIT" || pageName === "PORTFOLIO_FROM_RTA" || pageName === "BANK_SELECT" || pageName === "BANK_ACCOUNT_ADD" || pageName === "BANK_BRANCH_SEARCH" || pageName === "SUPPORTING_DOCUMENT" || pageName === "STATE_SELECTION")) {
      navigation.goBack();
    } else  if (isPLJ && userDetails?.linkedBorrowerAccounts[0]?.accountHolderEmail === null) {
      navigation.navigate(ROUTE.HOME)
    }
    else if(typeof manualHandle === 'function'){
      manualHandle()
    } else if(isLMSUser && navigation.canGoBack()) {
      navigation.goBack()
    } else {
      console.log('No screen to go back to.');
    }
  };
  return showBackButton && (
    <ThemedTouchableOpacity
      hitSlop={{ left: 15, right: 15, top: 15, bottom: 15 }}
      eventName={pageName ? pageName + '_BACK_BUTTON' : undefined}
      onPress={handleGoBack}>
      {Platform.OS === 'ios' ? (
        <CaretLeft size={20} color={colors['icon-primary']} />
      ) : (
        <ArrowLeft size={18} color={colors['icon-primary']}  />
      )}
    </ThemedTouchableOpacity>
  );
};

export default BackButton;
